import React, { useState } from "react";
import ShowAll from "./components/ShowAll/ShowAll";

interface CustomProps {
  setToggle: any;
  toggle: any;
}

const Team = (_props: CustomProps) => {
  const [tabValue] = useState<string>("Show All");

  function getContent() {
    switch (tabValue) {
      case "Show All":
        return <ShowAll />;
      default:
        return null;
    }
  }

  return (
    <div className="flex h-[calc(100vh-68px)] max-h-[calc(100vh-68px)] flex-col overflow-hidden bg-white p-4 sm:p-5 lg:p-6">
      <div className="mb-4 shrink-0">
        <h1 className="text-2xl font-bold tracking-tight text-[#111827]">
          Facebook Forms
        </h1>
        <p className="mt-1 text-sm text-[#6B7280]">
          View & manage all the Facebook Forms. Open a Pulse form on Lead Forms
          to copy its form-specific webhook URL.
        </p>
      </div>
      <div className="min-h-0 flex-1 overflow-auto">{getContent()}</div>
    </div>
  );
};

export default Team;
